import { render, staticRenderFns } from "./PsiFormCurrencyField.vue?vue&type=template&id=71bb3ffa&"
import script from "./PsiFormCurrencyField.vue?vue&type=script&lang=js&"
export * from "./PsiFormCurrencyField.vue?vue&type=script&lang=js&"
import style0 from "./PsiFormCurrencyField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71bb3ffa')) {
      api.createRecord('71bb3ffa', component.options)
    } else {
      api.reload('71bb3ffa', component.options)
    }
    module.hot.accept("./PsiFormCurrencyField.vue?vue&type=template&id=71bb3ffa&", function () {
      api.rerender('71bb3ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/forms/PsiFormCurrencyField.vue"
export default component.exports